import { lazyBackground, lazyLoadImage } from "../utils/utils";

export default class PageObserver {
	constructor() {
		this.config = {
			rootMargin: "0px 0px 50px 0px",
			threshold: 0,
		};

		this.observer = new IntersectionObserver((entries, self) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target.tagName === "IMG") {
						lazyLoadImage(entry.target);
						self.unobserve(entry.target);
					} else {
						if (entry.target.hasAttribute("data-background")) {
							lazyBackground(entry.target);
							self.unobserve(entry.target);

							return;
						}

						entry.target.classList.add("loaded");
						entry.target.classList.add("visible");
					}
				}
			});
		}, this.config);

		this.images = document.querySelectorAll(
			'[data-src], [data-background]'
		);

		this.images.forEach((image) => {
			this.observer.observe(image);
		});

		this.horizontalProgressBar = document.querySelectorAll('.progress__bar');
		this.horizontalProgressBar && this.horizontalProgressBar.forEach((progressContainer) => {
			let scrollingArea = progressContainer.parentNode.querySelector('.horizontal-scroll');
			let progressBar = progressContainer.querySelector('.progress__bar--filled');
			scrollingArea.addEventListener('scroll', event => {
				let scrolled = (scrollingArea.scrollLeft / (scrollingArea.scrollWidth - scrollingArea.clientWidth) ) * 100;
				progressBar.style.width = scrolled + "%";
			});
		});
	}
}
